import {
	moduleName,
	NOTIFY, notifyReducer
} from '../index'


export default {
	[moduleName + NOTIFY]: notifyReducer,
}